import { styled } from '@mui/material';

export const RootStyled = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.dark.dark_5}`,

  paddingTop: theme.spacing(2),
}));
